<script>
import options from './PickUpAddress.options'
export default options
</script>

<template>
  <article class="kb-pick-up-address">

    <h3 class="kb-pick-up-address__title">{{ getLabel('title') }}</h3>

    <div class="kb-pick-up-address__search-input">

      <FormAddressField 
        v-model:address-line-value="addressLineInput" 
        v-model:zip-code-value="postalCodeInput"
        v-model:city-value="cityInput" 
        :isValidationError="!addressLineInputFilled && !postalCodeInputFilled && !cityInputFilled"
        :errorMessageLabel="getLabel('searchValidation')" 
        :addressPlaceholder="getLabel('searchPlaceholder')"
        @update:addressSelected="handleAddressSelected"
        />

      <button @click="onSubmit" class="kb-pick-up-address__search-input-icon" title="Søg">
        <svg viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="10" cy="10" r="9.5" stroke="#ffffff" />
          <path d="M16 10a6 6 0 0 0-6-6M24.768 25.89l-6.718-6.718 2.122-2.122 7.778 7.778-1.82 1.82" stroke="#ffffff" />
        </svg>
      </button>
    </div>

    <ul class="kb-pick-up-address__list">

      <template v-for="(address, addressKey) in addressResults" :key="addressKey">

        <li class="kb-pick-up-address__list-item">
          <input 
            @change="setPickUpAddressInStore"
            :id="address.name" 
            type="radio" 
            name="pickup-address" 
            :value="address" autocomplete="off"
            v-model="addressRadioInput"
          >

          <label class="kb-pick-up-address__list-label" :for="address.name">
            <p class="kb-pick-up-address__list-label-title">{{ address.name }}</p>
            <p class="kb-pick-up-address__list-label-text">{{ address.addressLine }}</p>
            <p class="kb-pick-up-address__list-label-text">{{ `${address.zipCode} ${address.city}` }}</p>
          </label>

        </li>

      </template>

    </ul>

    <div v-if="displayInputErrors && !pickUpAddressData.addressLine" aria-live="assertive" class="kb-optimizely-forms">
      <p class="kb-forms Form__Element__ValidationError" role="alert">{{ getLabel('pickUpAddressErrorLabel') }}</p>
    </div>

  </article>
</template>
